<app-dialog-base [showLoadingSpinner]="uiState() === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Edit Charity Registration URL</span>

  <ng-container dialog-content>
  <form>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Charity Registration URL</mat-label>
      <input matInput data-testid="charity-registration-url-input" [formControl]="urlControl" placeholder="https://...">
      @if ((urlControl.dirty || urlControl.touched) && urlControl.errors) {
        <mat-error data-testid="charity-registration-url-error-message">
          Please enter a valid URL (starting with https://)
        </mat-error>
      }
    </mat-form-field>
    <p class="hint-text">Leave empty to hide the charity registration section on the landing page.</p>
  </form>
  </ng-container>

  <ng-container actions>
    <button mat-button class="btn-success" data-testid="charity-registration-url-submit-button" (click)="submit()">Submit</button>
  </ng-container>
</app-dialog-base>
